var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _vm.isBasketCrosssellingEnabled
            ? _c(
                "div",
                [
                  _c("add-to-basket", {
                    attrs: {
                      "data-testing": "item-add-to-basket",
                      "variation-id": _vm.item.variation.id,
                      "is-salable":
                        !!_vm.item.filter && _vm.item.filter.isSalable,
                      "has-children":
                        !!_vm.item.item &&
                        _vm.item.item.salableVariationCount > 1,
                      "interval-quantity":
                        _vm.item.variation.intervalOrderQuantity || 1,
                      "minimum-quantity":
                        _vm.item.variation.minimumOrderQuantity,
                      "maximum-quantity":
                        !!_vm.item.variation.maximumOrderQuantity &&
                        _vm.item.variation.maximumOrderQuantity > 0
                          ? _vm.item.variation.maximumOrderQuantity
                          : null,
                      "order-properties": _vm.item.properties.filter(function(
                        prop
                      ) {
                        return prop.property.isOderProperty
                      }),
                      "has-order-properties": _vm.item.hasOrderProperties,
                      "has-required-order-property":
                        _vm.item.hasRequiredOrderProperty,
                      "use-large-scale": false,
                      "show-quantity": true,
                      "item-url": _vm._f("itemURL")(
                        _vm.item,
                        _vm.urlWithVariationId
                      ),
                      "has-price": _vm._f("hasItemDefaultPrice")(_vm.item),
                      "has-graduated-price":
                        _vm.itemGraduatedPriceisCheapestSorting ||
                        _vm.itemGraduatedPricesalableVariationCount,
                      "item-type": _vm.item.item.itemType
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.prices.rrp &&
          _vm.item.prices.rrp.unitPrice.value > 0 &&
          _vm.item.prices.rrp.unitPrice.value >
            _vm.item.prices.default.unitPrice.value
            ? _c("div", { staticClass: "reduced-procent" }, [
                _c("p", [
                  _vm._v(
                    "- " +
                      _vm._s(
                        _vm._f("numberFormat")(
                          (1 -
                            _vm.item.prices.default.unitPrice.value /
                              _vm.item.prices.rrp.unitPrice.value) *
                            100,
                          0
                        )
                      ) +
                      "%"
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "thumb-image" }, [
            _c(
              "div",
              { staticClass: "prop-1-1" },
              [
                _vm._t("item-image", [
                  _vm._l(_vm.item.images, function(images, key) {
                    return [
                      _vm._l(images, function(image, index) {
                        return key == "all" && index <= 1
                          ? [
                              images.length > "1"
                                ? [
                                    index === 0
                                      ? _c(
                                          "div",
                                          { staticClass: "first-image" },
                                          [
                                            _vm.paddingClasses &&
                                            _vm.paddingClasses.includes(
                                              "preloadItemListImage"
                                            )
                                              ? [
                                                  _c("img", {
                                                    staticClass: "img-fluid",
                                                    attrs: {
                                                      src:
                                                        image.urlSecondPreview,
                                                      alt: _vm._f("itemName")(
                                                        _vm.item
                                                      )
                                                    }
                                                  })
                                                ]
                                              : [
                                                  _c("lazy-img", {
                                                    attrs: {
                                                      "picture-class":
                                                        "img-fluid",
                                                      "image-url":
                                                        image.urlSecondPreview,
                                                      alt: _vm._f("itemName")(
                                                        _vm.item
                                                      )
                                                    }
                                                  })
                                                ]
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    index === 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "hover-image-section"
                                          },
                                          [
                                            _c("lazy-img", {
                                              attrs: {
                                                "picture-class": "img-fluid",
                                                "image-url":
                                                  image.urlSecondPreview,
                                                alt: _vm._f("itemName")(
                                                  _vm.item
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "stars-section"
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                : [
                                    _vm.paddingClasses &&
                                    _vm.paddingClasses.includes(
                                      "preloadItemListImage"
                                    )
                                      ? [
                                          _c("img", {
                                            staticClass: "img-fluid",
                                            attrs: {
                                              src: image.urlSecondPreview,
                                              alt: _vm._f("itemName")(_vm.item)
                                            }
                                          })
                                        ]
                                      : [
                                          _c("lazy-img", {
                                            attrs: {
                                              "picture-class": "img-fluid",
                                              "image-url":
                                                image.urlSecondPreview,
                                              alt: _vm._f("itemName")(_vm.item)
                                            }
                                          })
                                        ],
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "hover-without-image-section"
                                    })
                                  ]
                            ]
                          : _vm._e()
                      })
                    ]
                  })
                ])
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm._t("store-special", [
            _vm.storeSpecial ||
            _vm.item.variation.bundleType === "bundle" ||
            _vm.item.item.itemType === "set"
              ? _c("item-store-special", {
                  attrs: {
                    "store-special": _vm.storeSpecial,
                    "recommended-retail-price": _vm.item.prices.rrp,
                    "variation-retail-price": _vm.item.prices.default,
                    "special-offer-price": _vm.item.prices.specialOffer,
                    "decimal-count": _vm.decimalCount,
                    "bundle-type": _vm.item.variation.bundleType,
                    "item-type": _vm.item.item.itemType
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm._t("item-details", [
            _c(
              "div",
              { staticClass: "thumb-content" },
              [
                _c(
                  "a",
                  {
                    staticClass: "thumb-title small stretched-link",
                    attrs: {
                      href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId),
                      "aria-label": _vm._f("itemName")(_vm.item)
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("itemName")(_vm.item)) +
                        " "
                    ),
                    _vm._l(_vm.item.groupedAttributes, function(attribute) {
                      return _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("translate")(
                              "Ceres::Template.itemGroupedAttribute",
                              attribute
                            )
                          )
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "thumb-meta mt-2" },
                  [
                    _vm._t("before-prices"),
                    _vm._v(" "),
                    _c("div", { staticClass: "prices float-left" }, [
                      _c(
                        "div",
                        { staticClass: "price" },
                        [
                          _vm.item.item.itemType === "set"
                            ? [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.itemSetPrice",
                                        { price: _vm.itemSetPrice }
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            : !!_vm.item.item &&
                              _vm.item.item.salableVariationCount > 1 &&
                              _vm.$ceres.isCheapestSorting
                            ? [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.itemFromPrice",
                                        { price: _vm.itemPrice }
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("specialOffer")(
                                        _vm.item.prices.default.unitPrice
                                          .formatted,
                                        _vm.item.prices,
                                        "unitPrice",
                                        "formatted"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.item.prices.rrp &&
                      _vm.item.prices.rrp.unitPrice.value > 0 &&
                      _vm.item.prices.rrp.unitPrice.value >
                        _vm.item.prices.default.unitPrice.value
                        ? _c("div", { staticClass: "price-view-port" }, [
                            _vm.item.prices.specialOffer
                              ? _c("del", { staticClass: "crossprice" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("itemCrossPrice")(
                                          _vm.item.prices.default.unitPrice
                                            .formatted,
                                          true
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ])
                              : _c("del", { staticClass: "crossprice" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("itemCrossPrice")(
                                          _vm.item.prices.rrp.unitPrice
                                            .formatted
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.filteredProperties.length > 0
                      ? [
                          _c(
                            "div",
                            { staticClass: "eek-img-section" },
                            _vm._l(_vm.filteredProperties, function(
                              property,
                              index
                            ) {
                              return _vm.isValidValue(property.values.value)
                                ? _c("lazy-img", {
                                    key: index,
                                    attrs: {
                                      "image-url": _vm.getImageUrl(
                                        property.values.value
                                      )
                                    }
                                  })
                                : _vm._e()
                            }),
                            1
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("after-prices"),
                _vm._v(" "),
                !(
                  _vm.item.unit.unitOfMeasurement === "C62" &&
                  _vm.item.unit.content === 1
                )
                  ? _c("div", { staticClass: "category-unit-price small" }, [
                      _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.item.unit.names.name))
                      ]),
                      _vm._v(" "),
                      _vm.item.variation.mayShowUnitPrice
                        ? _c("span", [
                            _vm._v(
                              " | " + _vm._s(_vm.item.prices.default.basePrice)
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "product-details-tab" }, [
                  _c("div", { staticClass: "shipping-information" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.item.variation.availability.names.name) +
                        "\n          "
                    )
                  ])
                ])
              ],
              2
            )
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }